import { of, pipe } from 'rxjs';
import { map as rxMap, share, withLatestFrom } from 'rxjs/operators';
import { metaValidationGroups } from '../../../utils/data';
import { fieldType, runType } from '../../../validations/constants';
import { getFieldsToValidateFromDescriptor } from '../../../validations/utils';
import validateFields from '../../../validations/validateFields';
import { actionNames } from '../../transfer/control';
import { updateValidationResultMultiple } from '../../transfer/transmission';
import { filterByActionType } from '../../utils';
import { validateSyncAndAsyncFields } from '../utils';
const createValidationParams = ([[{ arrayName }, validationGroups], formData, formDescriptor, formFieldState], reduxStore)=>({
        groups: validationGroups,
        runType: runType.FIELD,
        fieldsToValidate: getFieldsToValidateFromDescriptor(Object.fromEntries(Object.entries(formDescriptor).filter(([key, value])=>value.type === fieldType.ARRAY && key === arrayName || value.array === arrayName)), formData),
        formData,
        formFieldState,
        formDescriptor,
        reduxStore
    });
const validateArray = ({ formData$, formDescriptor$, formFieldState$ }, reduxStore)=>pipe(withLatestFrom(formData$, formDescriptor$, formFieldState$), rxMap((value)=>validateFields(createValidationParams(value, reduxStore))));
export const validateFieldArrayPromise = (action, formStream$, reduxStore)=>of(action).pipe(rxMap((action)=>[
            action.payload,
            metaValidationGroups(action)
        ]), validateSyncAndAsyncFields(formStream$, reduxStore, createValidationParams)).toPromise();
export default (({ control$, ...other$ }, reduxStore)=>{
    return control$.pipe(filterByActionType(actionNames.VALIDATE_FIELD_ARRAY), rxMap((action)=>[
            action.payload,
            metaValidationGroups(action)
        ]), validateArray(other$, reduxStore), rxMap((payload)=>updateValidationResultMultiple(payload)), share());
});
